import { faEye, faEyeSlash, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import DynamicTable from "../../../components/Tables";
import {
  createSystemUser,
  deleteUserCall,
  getSystemUser,
} from "../../../services/apis";

const Users = ({ className }) => {
  const profile = useSelector((state) => state.profile);
  const [agencyDetails, setAgencyDetails] = useState({
    agency: {},
    users: [],
  });

  const [deleteUser, setDeleteUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [usersData, setUsersData] = useState([]);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const cols = [
    {
      id: "serial",
      title: "S.No",
      isSortable: false,
      render: (_, index) => index + 1,
    },
    {
      id: "username",
      title: "Username",
      key: "username",
      isSortable: true,
      iskey: true,
      render: (value) => value,
    },
    {
      id: "email",
      title: "Email",
      key: "email",
      isSortable: true,
      iskey: true,
      render: (value) => value || "N/A",
    },
    {
      id: "role",
      title: "Role",
      key: "role",
      isSortable: true,
      iskey: true,
      render: (value) => value,
    },
    {
      id: "createdon",
      title: "Created On",
      key: "createdon",
      isSortable: true,
      iskey: true,
      render: (value) => {
        const date = new Date(value);
        return !isNaN(date)
          ? date.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "Invalid Date";
      },
    },

    {
      id: "active",
      title: "Status",
      key: "active",
      // isSortable: true,
      render: (row) => (
        <span
          className={`d-inline-flex align-items-center px-2 py-1 rounded fw-bold ${
            row.active ? "bg-success text-white" : "bg-danger text-white"
          }`}
          style={{ fontSize: "0.80rem", lineHeight: "0.9rem" }}
        >
          {row.active ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      id: "action",
      title: "Action",
      iskey: true,
      key: "userid",
      render: (value, row) => (
        // <div className="d-flex justify-content-center gap-x-1">
        <div>
          <div
            onClick={() => {
              console.log("value", value);
              setSelectedUserId(value);
              setDeleteUser(true);
            }}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={faTrash} className="text-danger" />
          </div>
        </div>
      ),
    },
  ];

  const addNewUser = useFormik({
    initialValues: {
      email: "",
      password: "",
      username: "",
    },
    validationSchema: Yup.object().shape({
      username: Yup.string()
        // .max(20, "System User Name cannot exceed 20 characters")
        .required("User name cannot be empty"),
      email: Yup.string()
        // .max(40, "System User Email cannot exceed 40 characters")
        .email("Enter a valid email address")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Enter a valid email address"
        )
        .required("email cannot be empty."),
      password: Yup.string()
        .required("Password cannot be empty.")
        .min(8, "Password must be at least 8 characters long.")
        .matches(
          /[A-Z]/,
          "Password must contain at least one uppercase letter."
        )
        .matches(
          /[a-z]/,
          "Password must contain at least one lowercase letter."
        )
        .matches(/[0-9]/, "Password must contain at least one number.")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one special character."
        ),
    }),
    onSubmit: async (values) => {
      setIsButtonClicked(true);
      const response = await createSystemUser(values);

      if (response.statuscode === 1) {
        toast.dismiss();
        toast.success(response.message || "System User Created Successfully");
        addNewUser.resetForm();
        setShowAddUserModal(false);
        fetchUsers();
      } else {
        toast.dismiss();
        toast.warning(response.message);
      }
      setIsButtonClicked(false);
    },
  });

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      const response = await getSystemUser();
      if (response && response.statuscode === 1) {
        setUsersData(response.data);
      } else {
        setError("Failed to fetch users data. Please try again later.");
      }
    } catch (error) {
      setError("Failed to fetch users data. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleDeleteConfirm = async () => {
    if (!selectedUserId) return;
    setIsLoading(true);
    {
      const result = await deleteUserCall({}, selectedUserId);

      if (result?.statuscode === 1) {
        setUsersData((prevUsers) =>
          prevUsers.filter((user) => user.userid !== selectedUserId)
        );
        toast.dismiss();
        toast.success("System User deleted Successfully.");
        setDeleteUser(false);
        fetchUsers();
      }
    }
  };
  useEffect(() => {
    if (!showAddUserModal) {
      addNewUser.resetForm();
    }
  }, [showAddUserModal]);

  return (
    <div className="p-4 flex flex-row bg-white rounded-4 mt-5">
      <ToastContainer />
      <div className="d-flex justify-content-between w-100 align-items-center mb-4">
        <h3 style={{ color: "#262B40", fontWeight: "bold" }} className="mt-2">
          Users List
        </h3>
        <Row>
          <Col md={12} className="d-flex justify-content-end">
            {usersData.length < 5 && (
              <Button
                className="text-white bg-gradient"
                variant="primary"
                onClick={() => setShowAddUserModal(true)}
              >
                ADD SYSTEM USER
              </Button>
            )}
          </Col>
        </Row>
      </div>

      {/* {error && <div className="error-message">{error}</div>} */}
      <DynamicTable
        cols={cols}
        response={usersData}
        isPaginate={false}
        numberOfData={5}
        headerClass="table-header"
        rowHover={true}
        fixedHeight={false}
        isBgTransparent={false}
        hideHeader={false}
        isloading={isLoading}
      />
      <Modal
        show={showAddUserModal}
        onHide={() => setShowAddUserModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add System User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={addNewUser.handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>System User Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="System User Name"
                name="username"
                style={{ backgroundColor: "#F7F7F8" }}
                value={addNewUser.values.username}
                onChange={addNewUser.handleChange}
                onBlur={addNewUser.handleBlur}
                maxLength={30}
                isInvalid={
                  addNewUser.touched.username && addNewUser.errors.username
                }
              />
              <Form.Control.Feedback type="invalid">
                {addNewUser.errors.username}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email Address"
                name="email"
                style={{ backgroundColor: "#F7F7F8" }}
                value={addNewUser.values.email}
                onChange={addNewUser.handleChange}
                onBlur={addNewUser.handleBlur}
                maxLength={50}
                isInvalid={addNewUser.touched.email && addNewUser.errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {addNewUser.errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  style={{ backgroundColor: "#F7F7F8" }}
                  value={addNewUser.values.password}
                  onChange={addNewUser.handleChange}
                  onBlur={addNewUser.handleBlur}
                  maxLength={30}
                  isInvalid={
                    !!(
                      addNewUser.touched.password && addNewUser.errors.password
                    )
                  }
                />
                <div
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "35px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                  onClick={handleTogglePassword}
                >
                  <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                </div>
                <Form.Control.Feedback type="invalid">
                  {addNewUser.errors.password}
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            <Modal.Footer>
              <Button
                type="submit"
                variant="primary"
                disabled={isButtonClicked}
                className="text-white bg-gradient"
              >
                {isButtonClicked ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Add User"
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={deleteUser} onHide={() => setDeleteUser(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to Delete this System User?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="text-white bg-gradient"
            onClick={handleDeleteConfirm}
          >
            Confirm Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Users;
